// Copy a value to the clipboard
export async function copyText({ value = '', onSuccess, onError }: { value?: string, onSuccess?: () => void, onError?: () => void }) {
  try {
    await navigator.clipboard.writeText(value);
    onSuccess?.();
  } catch (err) {
    onError?.();
  }
}